export default "__VITE_ASSET__ta6heF$I__"